import React, { forwardRef, useEffect, useState } from 'react';
import { Grid, Typography, Paper, ImageListItem, ImageListItemBar, ImageList, Box, } from '@mui/material';
import reportslogo from "../../assets/images/reportslogo.png";
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import workOrderSummaryRepositry from '../../api/repositories/workOrderSummaryRepositries';
import { FemsGraph, BemsGraph, MasterGraph } from "../../utility/apiURLS";
import { getAuthToken } from "../../utility/tokenUtility";
import axios from "axios";
import { format, isValid, parse } from 'date-fns';


const VendorWorkorder = forwardRef(({ data, serviceType, rowData }, ref) => {

  const token = getAuthToken("id_token");
  const API_Data = data?.[0] || {};
  
  const workordercategory = API_Data?.workordercategory || "";
  const [beforeImageURL, setBeforeImageURL] = useState([]);
  const [afterImageURL, setAfterImageURL] = useState([]);
  const [reportData, setReportData] = useState({});
  const [verifiedBy, setVerifiedBy] = useState("");
  const [filename, setFilename] = useState('');
  const [filenameUrl, setFilenameUrl] = useState([]);
  const [txtFilenameUrl, setTxtFilenameUrl] = useState("");
  const formatDate = (dateString) => {
    if (!dateString) {
      return '';
    }
    let parsedDate;
    if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(dateString)) {
      parsedDate = new Date(dateString);
    }
    else if (/\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}/.test(dateString)) {
      parsedDate = parse(dateString, 'dd/MM/yyyy HH:mm:ss', new Date());
    } else {
      return "Invalid date";
    }

    if (!isValid(parsedDate)) {
      return "Invalid date";
    }

    return format(parsedDate, 'dd/MM/yyyy HH:mm:ss');
  };
  function formatDates(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    return `${day}/${month}/${year}`; 
  }


  const calculateDownTimeHrs = (repairTimes = []) => {

    const totalMinutes = repairTimes?.reduce((prev, current) => {
      const duration = current?.repairDuration?.split(" "); // Split by space to handle "120 Mins"
      const minutes = parseInt(duration[0]) || 0; // Extract the numeric part
      return prev + minutes; // Add the minutes directly
    }, 0);
  
    const downTimeHrs = `${totalMinutes} Mins` || "0 Mins";
    return downTimeHrs;
   
  };
 
  
  
  const calculateResponseDuration = (startDateTime, endDateTime) => {
    const start = new Date(startDateTime);
    const end = new Date(endDateTime);
  
   let responseDuration = "0 Mins"; // Default duration
  
   if (!isNaN(start) && !isNaN(end)) {
     // Calculate duration only if both dates are valid
     const timeDifference = Math.abs(end - start);
     const totalMinutes = Math.floor(timeDifference / (1000 * 60)); // Convert milliseconds to total minutes
  
     responseDuration = `${totalMinutes} Mins`;
   } else {
     responseDuration = "0 Mins";
   }
   return responseDuration
 
  
  };


  const fetchData = async () => {
    try {

      if (workordercategory === "Scheduled") {

        if (serviceType === 'FEMS') {
          const data = API_Data;
          let getService = serviceType === "FEMS" ? "fem" : "bem"
          const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();
          const lovOptionsResponse = await workOrderSummaryRepositry.lovOptions();
          const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
          const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(getService);


          const mapEmployeeIdToName = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.employeename : '';
          };

          const mapEmployeeIdToCode = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.employeecode : '';
          };

          const mapEmployeeIdToDesignation = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.designation : '';
          };

          const maptoVendorDetails = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorname : '';
          };

          const maptoVendorCode = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorcode : '';
          };

          const maptoVendorPhoneNO = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorphoneno : '';
          };

          const maptoVendorEmail = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendoremail : '';
          };


          const mapFlagIdToLabel = (id) => {
            const flag = lovOptionsResponse?.femschworepairflags?.find(f => f?.id === id);
            return flag ? flag?.repairflag : '';
          };

          const mapPicIdToLabel = (id) => {
            const pic = lovOptionsResponse?.femschworepairpics?.find(p => p?.id === id);
            return pic ? pic?.repairpic : '';
          };

          const mapActivityIdToLabel = (id) => {
            const activity = lovOptionsResponse?.femschworepairactivities?.find(a => a?.id === id);
            return activity ? activity?.repairactivity : '';
          };

          // Mapping repairTracker data
          const repairTracker = data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders[0]?.femscheduledworepairdetails?.map((repairDetail) => {
            return {
              employeename: {
                id: repairDetail?.employeeid || "",
                employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
              },
              flag: {
                id: repairDetail?.femschworepairflagId || "",
                label: mapFlagIdToLabel(repairDetail?.femschworepairflagId) || ""
              },
              pic: {
                id: repairDetail?.femschworepairpicId || "",
                label: mapPicIdToLabel(repairDetail?.femschworepairpicId) || ""
              },
              activity: {
                id: repairDetail?.femschworepairactivityId || "",
                label: mapActivityIdToLabel(repairDetail?.femschworepairactivityId) || ""
              },
              startDateandTime: repairDetail?.repairstartdate || "",
              endDateandTime: repairDetail?.repairenddate || "",
              repairDuration: repairDetail?.repairduration || "",
              remarks: repairDetail?.remarks || "",
              preparationHours: repairDetail?.preparationhours || "",
              verificationHours: repairDetail?.verificationhours || "",
              id: repairDetail?.id || "",
              timeStamp: repairDetail?.timestamp || ""
            };
          }) || [];


          const mapItemCode = (id) => {
            const ic = itemCodeResponse?.find(ic => ic?.id === id);
            return ic ? ic?.itemcode : '';
          };
          const mapItemDesc = (id) => {
            const ic = itemCodeResponse?.find(ic => ic?.id === id);
            return ic ? ic.descriptionname : '';
          };

          // Mapping repairTracker data
          const partReplacement = data?.femscheduledworkorderheaders[0]?.femscheduledwopartsreplacedetails.map((partDetails) => {
            return {
              itemPartCode: {
                id: partDetails?.id || "",
                label: mapItemCode(partDetails?.itemcodeid) || "",
              },
              itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
              quantity: partDetails?.quantityused || "",
              partCost: parseFloat(partDetails?.partscost || 0)?.toFixed(2) || "",
              id: partDetails?.id || "",
              timeStamp: partDetails?.timestamp || "",
              editmode: true
            };
          }) || [];

          const refworkreq = {
            id: data?.femscheduledworkorderheaders[0]?.femdepartmentworkrequestheaderId || "",
            label: data?.femscheduledworkorderheaders[0]?.femdepartmentworkrequestheader?.deptworkrequestno || "",
          };

          const assetNo = {
            id: data?.assetId || "",
            label: data?.assetNo || "",
          };


          const taskcode = {
            id: data?.scheduledTaskcodeId || "",
            label: data?.scheduledTaskcode || ""
          };

          const compRespondedBy = {
            id: data?.completionEmployeeId || "",
            label: data?.completionEmployeename || ""
          };



          const startDateTime = data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.responsestartdate || "";
          const endDateandTime = data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.responseenddate || ''
          const downTimeHrs = calculateDownTimeHrs(repairTracker);
          const responseDuration = calculateResponseDuration(startDateTime, endDateandTime)

          const mappedData = {
            id: data?.id || "",
            serviceType: serviceType || "",
            workOrderNo: data?.workorderno || '',
            referenceWorkRequestNo: refworkreq || "",
            issueDateandTimeBasicDetails: data?.femscheduledworkorderheaders[0]?.targetdate || "",
            workorderDateandTime: data?.workorderdate || "",
            requestor: data?.femscheduledworkorderheaders[0]?.requestor || '',
            designation: data?.femscheduledworkorderheaders[0]?.designation || '',
            contactNo: data?.femscheduledworkorderheaders[0]?.contactno || '',
            assetNo: assetNo || [],
            modelNo: data?.femscheduledworkorderheaders?.[0]?.femassetregister?.model || "",
            serialNo: data?.femscheduledworkorderheaders?.[0]?.femassetregister?.serialno || "",
            oldAssetNo: data?.femscheduledworkorderheaders[0]?.femassetregister?.oldAssetNo || '',
            description: data?.assetDescription || '',
            underwarrenty: data?.femscheduledworkorderheaders[0]?.femassetregister?.isunderwarranty === true
              ? "Yes"
              : data?.femscheduledworkorderheaders[0]?.femassetregister?.isunderwarranty === false
                ? "No"
                : '',
            location: data?.locationdesc || '',
            workgroupDescription: `${data?.workGroup || ''}${(data?.workGroup && data?.wgdesc) ? " - " : ""}${data?.wgdesc || ''}` || '',
            workGroupId: data?.wgId || "",
            requestDetails: data?.femscheduledworkorderheaders[0]?.requestdetails || '',
            recivedDateandTime: data?.femscheduledworkorderheaders[0]?.receiveddate || "",
            category: {
              label: data?.workordercategory || "",
              isvisible: true || "",
              id: data?.femscheduledworkorderheaders[0]?.femworkordertype?.femworkordercategoryId || ""
            },
            type: {
              label: data?.femscheduledworkorderheaders[0]?.femworkordertype?.workordertype || "",
              isvisible: true,
              id: data?.femscheduledworkorderheaders[0]?.femworkordertype?.id || ""
            },
            priority: {
              label: data?.femscheduledworkorderheaders[0]?.femworkorderpriority?.workorderpriority || "",
              isvisible: true,
              id: data?.femscheduledworkorderheaders[0]?.femworkorderpriority?.id || ""
            },
            targetResponse: data?.femscheduledworkorderheaders[0]?.femwotargetresponse?.targetresponse || "",
            cancelledBy: data?.femscheduledworkorderheaders[0]?.cancelledby || '',
            reasonforCancellation: data?.femscheduledworkorderheaders[0]?.cancellationreason || '',
            ppmscheduletrackId: data?.femscheduledworkorderheaders[0]?.femppmscheduletrackId || "",
            performancetest: data?.femscheduledworkorderheaders[0]?.performancetest || "",
            electricalsafteytest: data?.femscheduledworkorderheaders[0]?.electricalsafteytest || "",
            processstatus: data?.femscheduledworkorderheaders[0]?.processstatus || "",
            completionInfo: {
              id: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.id || '',
              respondedBy: compRespondedBy || '',
              respondedDateandTime: data?.femscheduledworepairdetails?.[0]?.femscheduledwoassessmentheader?.[0]?.responsestartdate || "",
              duration: responseDuration,
              completionBy: {
                id: data?.completionByEmployeeId || "",
                label: data?.completionByEmployeename || "",
                value: data?.completionByEmployeename || ""
              },
              designation: mapEmployeeIdToDesignation(data?.completionByEmployeeId),
              startDateandTime: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.startdate || '',
              endDateandTime: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.enddate || '',
              actionTaken: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.actiontaken || '',
              downTimeHrs: downTimeHrs,
              costInfo: {
                editmode: true,
                breakDownCost: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : 0,
                poNumber: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || "",
                ppmCostByPurchaseOrder: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.ppmcost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : 0,
                poNumberByPurchaseOrder: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || "",
                ppmCostByContract: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : 0,
                contractReferenceNumber: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.contractrefno || "",
                totalSparePartCost: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.sparepartscost || "",
                totalWorkorderCost: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.totalwocost || ""
              }
            },
            assessments: {
              id: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.id || '',
              employeeID: mapEmployeeIdToCode(data?.assessmentEmployeeId || "") || '',
              employeeName: mapEmployeeIdToName(data?.assessmentEmployeeId || "") || '',
              designation: data?.assessmentDesignation || "",
              respondedStartDateandTime: formatDate(data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.responsestartdate || ""),
              respondedEndDateandTime: formatDate(data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.responseenddate || ''),
              taskCode: taskcode || '',
              taskDescription: data?.scheduledTaskdesc || '',
              repairType: data?.femworespondtype || '',
              repairTracker: repairTracker || [],
              vendorName: maptoVendorDetails(data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || "") || '',
              vendorCode: maptoVendorCode(data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || "") || '',
              vendorPhoneNo: maptoVendorPhoneNO(data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || "") || "",
              vendorEmail: maptoVendorEmail(data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || "") || "",
            },
            femunscheduledwopartsreplacedetails: partReplacement || [],
            Authorizedby: data?.authorizedby || "",
            // authorizeDesignation:mapEmployeeIdToDesignation()  
            AuthorizedbyDate: data?.authorizedbyDate || "",
            editmode: true
          };
         
          await setReportData(mappedData);

        } else {
          const data = API_Data;
          let getService = serviceType === "FEMS" ? "fem" : "bem"

          const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();
          const lovOptionsResponse = await workOrderSummaryRepositry.lovOptions();
          const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
          const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(getService);

          const mapEmployeeIdToName = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee.employeename : '';
          };

          const mapEmployeeIdToCode = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.employeecode : '';

          };

          const mapEmployeeIdToDesignation = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.designation : '';
          };

          const mapFlagIdToLabel = (id) => {
            const flag = lovOptionsResponse?.femuschworepairflags?.find(f => f?.id === id);
            return flag ? flag?.repairflag : '';
          };

          const maptoVendorDetails = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorname : '';
          };


          const maptoVendorCode = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorcode : '';
          };

          const maptoVendorPhoneNO = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorphoneno : '';
          };

          const maptoVendorEmail = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendoremail : '';
          };

          const mapPicIdToLabel = (id) => {
            const pic = lovOptionsResponse?.femuschworepairpics?.find(p => p?.id === id);
            return pic ? pic?.repairpic : '';
          };

          const mapActivityIdToLabel = (id) => {
            const activity = lovOptionsResponse?.femuschworepairactivities?.find(a => a?.id === id);
            return activity ? activity?.repairactivity : '';
          };

          // Mapping repairTracker data
          const repairTracker = data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemscheduledworepairdetails?.map((repairDetail) => {
            return {
              employeename: {
                id: repairDetail?.employeeid || "",
                employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
              },
              flag: {
                id: repairDetail?.bemschworepairflagId || '',
                label: mapFlagIdToLabel(repairDetail?.bemschworepairflagId) || ''
              },
              pic: {
                id: repairDetail?.bemschworepairpicId || '',
                label: mapPicIdToLabel(repairDetail?.bemschworepairpicId) || ''
              },
              activity: {
                id: repairDetail.bemschworepairactivityId || '',
                label: mapActivityIdToLabel(repairDetail?.bemschworepairactivityId) || ''
              },
              startDateandTime: repairDetail?.repairstartdate || "",
              endDateandTime: repairDetail?.repairenddate || "",
              repairDuration: repairDetail?.repairduration || "",
              remarks: repairDetail?.remarks || '',
              preparationHours: repairDetail?.preparationhours || '',
              verificationHours: repairDetail?.verificationhours || '',
              id: repairDetail?.id || "",
              timeStamp: repairDetail?.timestamp || ""
            };
          }) || [];

          const mapItemCode = (id) => {
            const ic = itemCodeResponse?.find(ic => ic?.id === id);
            return ic ? ic.itemcode : '';
          };
          const mapItemDesc = (id) => {
            const ic = itemCodeResponse?.find(ic => ic?.id === id);
            return ic ? ic?.descriptionname : '';
          };
          // Mapping repairTracker data
          const partReplacement = data?.bemscheduledworkorderheaders[0]?.bemscheduledwopartsreplacedetails?.map((partDetails) => {
            return {
              itemPartCode: {
                id: partDetails?.id || "",
                label: mapItemCode(partDetails?.itemcodeid) || "",
              },
              itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
              quantity: partDetails?.quantityused || "",
              partCost: parseFloat(partDetails?.partscost || 0).toFixed(2) || "",
              id: partDetails?.id || "",
              editmode: true,
              timeStamp: partDetails?.timestamp || "",
            };
          }) || [];

          const startDateTime = data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.responsestartdate || "";
          const endDateandTime = data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.responseenddate || '';
          const downTimeHrs = calculateDownTimeHrs(repairTracker);
          const responseDuration = calculateResponseDuration(startDateTime, endDateandTime)

          const refworkreq = {
            id: data?.bemscheduledworkorderheaders[0]?.bemdepartmentworkrequestheaderId || "",
            label: data?.bemscheduledworkorderheaders[0]?.bemdepartmentworkrequestheader?.deptworkrequestno || "",
          };

          const assetNo = {
            id: data?.assetId || "",
            label: data?.assetNo || "",
          };

          const taskcode = {
            id: data?.scheduledTaskcodeId || "",
            label: data?.scheduledTaskcode || ""
          };

          const compRespondedBy = {
            id: data?.completionEmployeeId || "",
            label: data?.completionEmployeename || ""
          };

          const mappedData = {
            id: data?.id || "",
            serviceType: serviceType || "",
            workOrderNo: data?.workorderno || '',
            referenceWorkRequestNo: refworkreq || "",
            issueDateandTimeBasicDetails: data?.bemscheduledworkorderheaders?.[0]?.targetdate || "",
            workorderDateandTime: data?.workorderdate || "",
            requestor: data?.bemscheduledworkorderheaders?.[0]?.requestor || '',
            designation: data?.bemscheduledworkorderheaders?.[0]?.designation || '',
            contactNo: data?.bemscheduledworkorderheaders?.[0]?.contactno || '',
            assetNo: assetNo || [],
            modelNo: data?.bemscheduledworkorderheaders?.[0]?.bemassetregister?.model || "",
            serialNo: data?.bemscheduledworkorderheaders?.[0]?.bemassetregister?.serialno || "",
            oldAssetNo: data?.bemscheduledworkorderheaders?.[0]?.bemassetregister?.oldAssetNo || '',
            description: data.assetDescription || '',
            underwarrenty: data?.bemscheduledworkorderheaders?.[0]?.bemassetregister?.isunderwarranty === true
              ? "Yes"
              : data?.bemscheduledworkorderheaders?.[0]?.bemassetregister?.isunderwarranty === false
                ? "No"
                : '',
            location: data.locationdesc || '',
            workGroupId: data?.wgId || "",
            workgroupDescription: `${data?.workGroup || ''}${(data?.workGroup && data?.wgdesc) ? " - " : ""}${data?.wgdesc || ''}` || '',
            requestDetails: data?.bemscheduledworkorderheaders?.[0]?.requestdetails || '',
            recivedDateandTime: data?.bemscheduledworkorderheaders?.[0]?.receiveddate || "",
            category: {
              label: data?.workordercategory || "",
              isvisible: true,
              id: data?.bemscheduledworkorderheaders?.[0]?.bemworkordertype?.bemworkordercategoryId || ""
            },
            type: {
              label: data?.bemscheduledworkorderheaders?.[0]?.bemworkordertype?.workordertype || "",
              isvisible: true,
              id: data?.bemscheduledworkorderheaders?.[0]?.bemworkordertype?.id || ""
            },
            priority: {
              label: data?.bemscheduledworkorderheaders?.[0]?.bemworkorderpriority?.workorderpriority || "",
              isvisible: true,
              id: data?.bemscheduledworkorderheaders?.[0]?.bemworkorderpriority?.id || ""
            },
            targetResponse: data?.bemscheduledworkorderheaders?.[0]?.bemwotargetresponse?.targetresponse || "",
            cancelledBy: data?.bemscheduledworkorderheaders?.[0]?.cancelledby || '',
            reasonforCancellation: data?.bemscheduledworkorderheaders?.[0]?.cancellationreason || '',
            ppmscheduletrackId: data?.bemscheduledworkorderheaders?.[0]?.bemppmscheduletrackId || "",
            performancetest: data?.bemscheduledworkorderheaders[0]?.performancetest || "",
            electricalsafteytest: data?.bemscheduledworkorderheaders[0]?.electricalsafteytest || "",
            processstatus: data?.bemscheduledworkorderheaders[0]?.processstatus || "",
            completionInfo: {
              id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.id || '',
              respondedBy: compRespondedBy || '',
              respondedDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheader?.[0]?.responsestartdate || "",
              duration: responseDuration,
              completionBy: {
                id: data?.completionByEmployeeId || "",
                label: data?.completionByEmployeename || "",
                value: data?.completionByEmployeename || ""
              },
              designation: mapEmployeeIdToDesignation(data?.completionByEmployeeId || ""),
              startDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.startdate || '',
              endDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.enddate || '',
              actionTaken: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.actiontaken || '',
              downTimeHrs: downTimeHrs,
              costInfo: {
                editmode: true,
                breakDownCost: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : 0,
                poNumber: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || '',
                ppmCostByPurchaseOrder: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : 0,
                poNumberByPurchaseOrder: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || '',
                ppmCostByContract: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : 0,
                contractReferenceNumber: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractrefno || '',
                totalSparePartCost: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.sparepartscost || '',
                totalWorkorderCost: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.totalwocost || ''
              }
            },
            assessments: {
              id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders[0]?.id || '',
              employeeID: mapEmployeeIdToCode(data?.assessmentEmployeeId || "") || '',
              employeeName: mapEmployeeIdToName(data?.assessmentEmployeeId || "") || '',
              designation: data?.assessmentDesignation || "",
              respondedStartDateandTime: formatDate(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.responsestartdate || ""),
              respondedEndDateandTime: formatDate(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.responseenddate || ''),
              taskCode: taskcode || '',
              taskDescription: data?.scheduledTaskdesc || '',
              repairType: data?.bemworespondtype || '',
              repairTracker: repairTracker || [],
              vendorName: maptoVendorDetails(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || "") || '',
              vendorCode: maptoVendorCode(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || "") || '',
              vendorPhoneNo: maptoVendorPhoneNO(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || "") || "",
              vendorEmail: maptoVendorEmail(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || "") || "",
            },
            femunscheduledwopartsreplacedetails: partReplacement,
            Authorizedby: data?.authorizedby || "",
            AuthorizedbyDate: data?.authorizedbyDate || "",
          };
          await setReportData(mappedData);
        };


      } else {

        if (serviceType === 'FEMS') {
          const data = API_Data;
          let getService = serviceType === "FEMS" ? "fem" : "bem"

          const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();
          const lovOptionsResponse = await workOrderSummaryRepositry.lovOptions();
          const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
          const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(getService);


          const mapEmployeeIdToName = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.employeename : '';

          };
          const mapEmployeeIdToCode = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.employeecode : '';

          };

          const mapEmployeeIdToDesignation = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.designation : '';
          };

          const mapFlagIdToLabel = (id) => {
            const flag = lovOptionsResponse?.femuschworepairflags.find(f => f?.id === id);
            return flag ? flag?.repairflag : '';
          };

          const mapPicIdToLabel = (id) => {
            const pic = lovOptionsResponse?.femuschworepairpics.find(p => p?.id === id);
            return pic ? pic?.repairpic : '';
          };

          const mapActivityIdToLabel = (id) => {
            const activity = lovOptionsResponse?.femuschworepairactivities.find(a => a?.id === id);
            return activity ? activity?.repairactivity : '';
          };

          // Mapping repairTracker data
          const repairTracker = data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.femunscheduledworepairdetails?.map((repairDetail) => {
            return {
              employeename: {
                id: repairDetail?.employeeid || "",
                employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
              },
              flag: {
                id: repairDetail?.femuschworepairflagId || '',
                label: mapFlagIdToLabel(repairDetail?.femuschworepairflagId) || ''
              },
              pic: {
                id: repairDetail?.femuschworepairpicId || '',
                label: mapPicIdToLabel(repairDetail?.femuschworepairpicId) || ''
              },
              activity: {
                id: repairDetail?.femuschworepairactivityId || '',
                label: mapActivityIdToLabel(repairDetail?.femuschworepairactivityId) || ''
              },
              startDateandTime: repairDetail?.repairstartdate || "",
              endDateandTime: repairDetail?.repairenddate || "",
              repairDuration: repairDetail?.repairduration || "",
              remarks: repairDetail?.remarks || "",
              preparationHours: repairDetail?.preparationhours || '',
              verificationHours: repairDetail?.verificationhours || '',
              id: repairDetail?.id || "",
              timeStamp: repairDetail?.timestamp || ""
            };
          }) || [];

          const mapItemCode = (id) => {
            const ic = itemCodeResponse?.find(ic => ic?.id === id);
            return ic ? ic?.itemcode : '';
          };
          const mapItemDesc = (id) => {
            const ic = itemCodeResponse?.find(ic => ic?.id === id);
            return ic ? ic?.descriptionname : '';
          };
          // Mapping repairTracker data
          const partReplacement = data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwopartsreplacedetails?.map((partDetails) => {

            return {
              itemPartCode: {
                id: partDetails?.itemcodeid || "",
                label: mapItemCode(partDetails?.itemcodeid) || "",
              },
              itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
              quantity: partDetails?.quantityused || "",
              partCost: parseFloat(partDetails?.partscost || 0)?.toFixed(2) || "",
              id: partDetails?.id || "",
              editmode: true,
              timeStamp: partDetails?.timestamp || "",
            };
          }) || [];

          const refworkreq = {
            id: data?.femunscheduledworkorderheaders?.[0]?.femdepartmentworkrequestheaderId || "",
            label: data?.femunscheduledworkorderheaders?.[0]?.femdepartmentworkrequestheader?.deptworkrequestno || "",
          };

          const assetNo = {
            id: data?.assetId || "",
            label: data?.assetNo || "",
          };

          const taskcode = {
            id: data?.taskcodeId || "",
            label: data?.taskcode || ""
          };


          const compRespondedBy = {
            id: data?.completionEmployeeId || "",
            label: data?.completionEmployeename || ""
          };

          const maptoVendorDetails = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorname : '';
          }
          const maptoVendorCode = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorcode : '';
          };

          const maptoVendorPhoneNO = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorphoneno : '';
          };

          const maptoVendorEmail = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendoremail : '';
          };

          const startDateTime = data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.responsestartdate || "";
          const endDateandTime = data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.responseenddate || '';
          const downTimeHrs = calculateDownTimeHrs(repairTracker);
          const responseDuration = calculateResponseDuration(startDateTime, endDateandTime)

          const mappedData = {
            id: data?.id || "",
            serviceType: serviceType || "",
            workOrderNo: data?.workorderno || '',
            referenceWorkRequestNo: refworkreq || "",
            issueDateandTimeBasicDetails: data?.femunscheduledworkorderheaders?.[0]?.targetdate || "",
            workorderDateandTime: data?.workorderdate || "",
            requestor: data?.femunscheduledworkorderheaders?.[0]?.requestor || '',
            designation: data?.femunscheduledworkorderheaders?.[0]?.designation || '',
            contactNo: data?.femunscheduledworkorderheaders?.[0]?.contactno || '',
            assetNo: assetNo || [],
            modelNo: data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.model || "",
            serialNo: data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.serialno || "",
            oldAssetNo: data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.oldAssetNo || '',
            description: data?.assetDescription || '',
            underwarrenty: data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.isunderwarranty === true
              ? "Yes"
              : data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.isunderwarranty === false
                ? "No"
                : '',
            location: data?.locationdesc || '',
            workGroupId: data?.wgId || "",
            workgroupDescription: `${data?.workGroup || ''}${(data?.workGroup && data?.wgdesc) ? " - " : ""}${data?.wgdesc || ''}` || '',
            requestDetails: data?.femunscheduledworkorderheaders?.[0]?.requestdetails || '',
            recivedDateandTime: data?.femunscheduledworkorderheaders?.[0]?.receiveddate || "",
            category: {
              label: data?.workordercategory || "",
              isvisible: true,
              id: data?.femunscheduledworkorderheaders?.[0]?.femworkordertype?.femworkordercategoryId || ""
            },
            type: {
              label: data?.femunscheduledworkorderheaders?.[0]?.femworkordertype?.workordertype || "",
              isvisible: true,
              id: data?.femunscheduledworkorderheaders?.[0]?.femworkordertype?.id || ""
            },
            priority: {
              label: data?.femunscheduledworkorderheaders?.[0]?.femworkorderpriority?.workorderpriority || "",
              isvisible: true,
              id: data?.femunscheduledworkorderheaders?.[0]?.femworkorderpriority?.id || ""
            },
            targetResponse: data?.femunscheduledworkorderheaders?.[0]?.femwotargetresponse?.targetresponse || "",
            cancelledBy: data?.femunscheduledworkorderheaders?.[0]?.cancelledby || '',
            reasonforCancellation: data?.femunscheduledworkorderheaders?.[0]?.cancellationreason || '',
            performancetest: data?.femunscheduledworkorderheaders?.performancetest || "",
            electricalsafteytest: data?.femunscheduledworkorderheaders?.electricalsafteytest || "",
            processstatus: data?.femunscheduledworkorderheaders?.processstatus || "",
            completionInfo: {
              id: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.id || '',
              respondedBy: compRespondedBy || '',
              respondedDateandTime: data?.femunscheduledworepairdetails?.[0]?.femunscheduledwoassessmentheader?.[0]?.responsestartdate || "",
              duration: responseDuration || '',
              completionBy: {
                id: data?.completionByEmployeeId || "",
                label: data?.completionByEmployeename || "",
                value: data?.completionByEmployeename || ""
              },
              designation: mapEmployeeIdToDesignation(data?.completionByEmployeeId || ""),
              startDateandTime: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.startdate || '',
              endDateandTime: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.enddate || '',
              actionTaken: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.actiontaken || '',
              downTimeHrs: downTimeHrs,
              costInfo: {
                editmode: true,
                breakDownCost: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : 0,
                poNumber: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || '',
                ppmCostByPurchaseOrder: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.ppmcost ? parseFloat(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : 0,
                poNumberByPurchaseOrder: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || '',
                ppmCostByContract: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : 0,
                contractReferenceNumber: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.contractrefno || '',
                totalSparePartCost: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.sparepartscost || '',
                totalWorkorderCost: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.totalwocost || ''
              }
            },
            assessments: {
              id: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.id || '',
              employeeID: mapEmployeeIdToCode(data?.assessmentEmployeeId || "") || '',
              employeeName: mapEmployeeIdToName(data?.assessmentEmployeeId || "") || '',
              designation: data?.assessmentDesignation || "",
              respondedStartDateandTime: formatDate(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.responsestartdate || ""),
              respondedEndDateandTime: formatDate(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.responseenddate || ''),
              taskCode: taskcode || '',
              taskDescription: data?.taskdesc || '',
              repairType: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype || '',
              respondedFinding: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.respondfinding || '',
              repairTracker: repairTracker || [],
              vendorName: maptoVendorDetails(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.vendorid || "") || '',
              vendorCode: maptoVendorCode(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.vendorid || "") || '',
              vendorPhoneNo: maptoVendorPhoneNO(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.vendorid || "") || "",
              vendorEmail: maptoVendorEmail(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.vendorid || "") || "",
            },
            femunscheduledwopartsreplacedetails: partReplacement,
            Authorizedby: data?.authorizedby || "",
            AuthorizedbyDate: data?.authorizedbyDate || "",
          };
          await setReportData(mappedData);

        } else {
          const data = API_Data;
          let getService = serviceType === "FEMS" ? "fem" : "bem"

          const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();
          const lovOptionsResponse = await workOrderSummaryRepositry.lovOptions();
          const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
          const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(getService);

          const mapEmployeeIdToName = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.employeename : '';
          };

          const mapEmployeeIdToCode = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.employeecode : '';

          };

          const mapEmployeeIdToDesignation = (id) => {
            const employee = employeeResponse?.find(emp => emp?.id === id);
            return employee ? employee?.designation : '';
          };

          const mapFlagIdToLabel = (id) => {
            const flag = lovOptionsResponse?.femuschworepairflags?.find(f => f?.id === id);
            return flag ? flag?.repairflag : '';
          };

          const mapPicIdToLabel = (id) => {
            const pic = lovOptionsResponse?.femuschworepairpics?.find(p => p?.id === id);
            return pic ? pic?.repairpic : '';
          };

          const mapActivityIdToLabel = (id) => {
            const activity = lovOptionsResponse?.femuschworepairactivities?.find(a => a?.id === id);
            return activity ? activity?.repairactivity : '';
          };

          // Mapping repairTracker data
          const repairTracker = data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.bemunscheduledworepairdetails?.map((repairDetail) => {
            return {
              employeename: {
                id: repairDetail?.employeeid || "",
                employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
              },
              flag: {
                id: repairDetail?.bemuschworepairflagId || '',
                label: mapFlagIdToLabel(repairDetail?.bemuschworepairflagId) || ''
              },
              pic: {
                id: repairDetail?.bemuschworepairpicId || '',
                label: mapPicIdToLabel(repairDetail?.bemuschworepairpicId) || ''
              },
              activity: {
                id: repairDetail?.bemuschworepairactivityId || '',
                label: mapActivityIdToLabel(repairDetail?.bemuschworepairactivityId) || ''
              },
              startDateandTime: repairDetail?.repairstartdate || "",
              endDateandTime: repairDetail?.repairenddate || "",
              repairDuration: repairDetail?.repairduration || "",
              remarks: repairDetail?.remarks || '',
              preparationHours: repairDetail?.preparationhours || '',
              verificationHours: repairDetail?.verificationhours || '',
              id: repairDetail?.id || "",
              timeStamp: repairDetail?.timestamp || ""
            };
          }) || [];

          const mapItemCode = (id) => {
            const ic = itemCodeResponse?.find(ic => ic?.id === id);
            return ic ? ic.itemcode : '';
          };
          const mapItemDesc = (id) => {
            const ic = itemCodeResponse?.find(ic => ic?.id === id);
            return ic ? ic?.descriptionname : '';
          };
          // Mapping repairTracker data
          const partReplacement = data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwopartsreplacedetails?.map((partDetails) => {
            return {
              itemPartCode: {
                id: partDetails?.id || "",
                label: mapItemCode(partDetails?.itemcodeid) || "",
              },
              itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
              quantity: partDetails?.quantityused || "",
              partCost: parseFloat(partDetails?.partscost || 0).toFixed(2) || "",
              id: partDetails?.id || "",
              editmode: true,
              timeStamp: partDetails?.timestamp || "",
            };
          }) || [];

          const startDateTime = data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.responsestartdate || "";
          const endDateandTime = data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.responseenddate || '';
          const downTimeHrs = calculateDownTimeHrs(repairTracker);
          const responseDuration = calculateResponseDuration(startDateTime, endDateandTime)

          const refworkreq = {
            id: data?.bemunscheduledworkorderheaders?.[0]?.bemdepartmentworkrequestheaderId || "",
            label: data?.bemunscheduledworkorderheaders?.[0]?.bemdepartmentworkrequestheader?.deptworkrequestno || "",
          };


          const assetNo = {
            id: data?.assetId || "",
            label: data?.assetNo || "",
          };

          const taskcode = {
            id: data?.taskcodeId || "",
            label: data?.taskcode || ""
          };

          const compRespondedBy = {
            id: data?.completionEmployeeId || "",
            label: data?.completionEmployeename || ""
          };

          const maptoVendorDetails = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorname : '';
          }
          const maptoVendorCode = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorcode : '';
          };

          const maptoVendorPhoneNO = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendorphoneno : '';
          };

          const maptoVendorEmail = (id) => {
            const vendor = vendorDetails?.find(v => v?.id === id);
            return vendor ? vendor?.vendoremail : '';
          };


          const mappedData = {
            id: data?.id || "",
            serviceType: serviceType || "",
            workOrderNo: data?.workorderno || '',
            referenceWorkRequestNo: refworkreq || "",
            issueDateandTimeBasicDetails: data?.bemunscheduledworkorderheaders?.[0]?.targetdate || "",
            workorderDateandTime: data?.workorderdate || "",
            requestor: data?.bemunscheduledworkorderheaders?.[0]?.requestor || '',
            designation: data?.bemunscheduledworkorderheaders?.[0]?.designation || '',
            contactNo: data?.bemunscheduledworkorderheaders?.[0]?.contactno || '',
            assetNo: assetNo || [],
            modelNo: data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.model || "",
            serialNo: data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.serialno || "",
            oldAssetNo: data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.oldAssetNo || '',
            description: data?.assetDescription || '',
            underwarrenty: data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.isunderwarranty === true
              ? "Yes"
              : data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.isunderwarranty === false
                ? "No"
                : '',
            location: data.locationdesc || '',
            workGroupId: data?.wgId || "",
            workgroupDescription: `${data?.workGroup || ''}${(data?.workGroup && data?.wgdesc) ? " - " : ""}${data?.wgdesc || ''}` || '',
            requestDetails: data?.bemunscheduledworkorderheaders?.[0]?.requestdetails || '',
            recivedDateandTime: data?.bemunscheduledworkorderheaders?.[0]?.receiveddate || "",
            category: {
              label: data?.workordercategory || "",
              isvisible: true,
              id: data?.bemunscheduledworkorderheaders?.[0]?.bemworkordertype?.bemworkordercategoryId || ""
            },
            type: {
              label: data?.bemunscheduledworkorderheaders?.[0]?.bemworkordertype?.workordertype || "",
              isvisible: true,
              id: data?.bemunscheduledworkorderheaders?.[0]?.bemworkordertype?.id || ""
            },
            priority: {
              label: data?.bemunscheduledworkorderheaders?.[0]?.bemworkorderpriority?.workorderpriority || "",
              isvisible: true,
              id: data?.bemunscheduledworkorderheaders?.[0]?.bemworkorderpriority?.id || ""
            },
            targetResponse: data?.bemunscheduledworkorderheaders?.[0]?.bemwotargetresponse?.targetresponse || "",
            cancelledBy: data?.bemunscheduledworkorderheaders?.[0]?.cancelledby || '',
            reasonforCancellation: data?.bemunscheduledworkorderheaders?.[0]?.cancellationreason || '',
            performancetest: data?.bemunscheduledworkorderheaders?.performancetest || "",
            electricalsafteytest: data?.bemunscheduledworkorderheaders?.electricalsafteytest || "",
            processstatus: data?.bemunscheduledworkorderheaders?.processstatus || "",
            completionInfo: {
              id: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.id || '',
              respondedBy: compRespondedBy || '',
              respondedDateandTime: data?.bemunscheduledworepairdetails?.[0]?.bemunscheduledwoassessmentheader[0]?.responsestartdate || "",
              duration: responseDuration || '',
              completionBy: {
                id: data?.completionByEmployeeId || "",
                label: data?.completionByEmployeename || "",
                value: data?.completionByEmployeename || ""
              },
              designation: mapEmployeeIdToDesignation(data?.completionByEmployeeId || ""),
              startDateandTime: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.startdate || '',
              endDateandTime: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.enddate || '',
              actionTaken: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.actiontaken || '',
              downTimeHrs: downTimeHrs,
              costInfo: {
                editmode: true,
                breakDownCost: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : 0,
                poNumber: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || '',
                ppmCostByPurchaseOrder: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.ppmcost ? parseFloat(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : 0,
                poNumberByPurchaseOrder: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || '',
                ppmCostByContract: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : 0,
                contractReferenceNumber: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.contractrefno || '',
                totalSparePartCost: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.sparepartscost || '',
                totalWorkorderCost: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.totalwocost || ''
              }
            },
            assessments: {
              id: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.id || '',
              employeeID: mapEmployeeIdToCode(data?.assessmentEmployeeId || "") || '',
              designation: data?.assessmentDesignation || "",
              employeeName: mapEmployeeIdToName(data?.assessmentEmployeeId || "") || '',
              respondedStartDateandTime: formatDate(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.responsestartdate || ""),
              respondedEndDateandTime: formatDate(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.responseenddate || ''),
              taskCode: taskcode || '',
              taskDescription: data?.taskdesc || '',
              repairType: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype || '',
              repairTracker: repairTracker || [],
              vendorName: maptoVendorDetails(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.vendorid || "") || '',
              vendorCode: maptoVendorCode(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.vendorid || "") || '',
              vendorPhoneNo: maptoVendorPhoneNO(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.vendorid || "") || "",
              vendorEmail: maptoVendorEmail(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.vendorid || "") || "",
            },
            femunscheduledwopartsreplacedetails: partReplacement,
            Authorizedby: data?.authorizedby || "",
            AuthorizedbyDate: data?.authorizedbyDate || "",
          };

          await setReportData(mappedData)
        };
      };

    } catch (error) {
    //   console.error("Error fetching data:", error);
    }
  };
  const fetchFiles = async () => {
    const checkFemorBem = serviceType === "FEMS" ? "Fem" : "Bem";
    const getAttachementCategory = workordercategory === "Scheduled" ? "GetscheduledAttachmentsList" : "GetunscheduledAttachmentsList";
    const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;
    const checkFieldName = serviceType === "FEMS" ? "fem" : "bem";
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await axios.get(`${checkGraph}/api/${checkFemorBem}unscheduledworkorder/${getAttachementCategory}/${data?.[0]?.workOrderId},1,1000`, config);
      const fetchedFiles = response.data;
      const gridRows = fetchedFiles.map((file) => ({
        id: file?.id,
        filename: file?.filename,
        filepath: file?.filepath,
        filesize: file?.filesize,
        documenttitle: file?.documenttitle,
        documenttype: file?.documenttitle?.split('.')?.pop()?.toLowerCase(),
        attachmentType: file?.[`${checkFieldName}woattachmenttypeId`], // Check the type here
      }));

      if (response?.data?.length > 0) {
        fetchImagesForFiles(gridRows); // Pass the fetched files here
      }
    } catch (error) {
    //   console.error('Error fetching files:', error);
    }
  };

 



  const fetchImagesForFiles = async (files) => {
    try {

      if (!files || !Array.isArray(files) || files.length === 0) {
        return;
      }

      const updatedFiles = await Promise.all(
        files.map(async (file) => {
          try {
            const imageurl = `${MasterGraph}/api/FileUpload/DownloadFile/${file.filename}`;
            const response = await fetch(imageurl, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`,
              },
            });

            if (response.ok) {
              const blob = await response.blob();
              const reader = new FileReader();

              return new Promise((resolve) => {
                reader.onloadend = () => {
                  resolve({ ...file, url: reader.result });
                };
                reader.onerror = () => {
                  resolve({ ...file, url: null });
                };
                reader.readAsDataURL(blob);
              });
            } else {
              return { ...file, url: null };
            }
          } catch (error) {
            // console.error('Error processing file:', file.filename, error);
            return { ...file, url: null };
          }
        })
      );

      const beforeImages = updatedFiles.filter(file => file.attachmentType === 1);
      const afterImages = updatedFiles.filter(file => file.attachmentType === 2);
      setBeforeImageURL(beforeImages);
      setAfterImageURL(afterImages);
    } catch (error) {
    //   console.error('Error fetching images:', error);
    }
  };
  async function processFilesWithUrls(files, token) {
    if (!Array.isArray(files)) {
    //   console.error("Expected an array, but received:", files);
      if (typeof files === "string" && files.startsWith("data:image/")) {
        return [{ url: files }];
      }
      return [];
    }

    return await Promise.all(
      files.map(async (file) => {
        try {
          const imageurl = `${MasterGraph}/api/FileUpload/DownloadFile/${file.filename}`;
          const response = await fetch(imageurl, {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          });

          if (response.ok) {
            const blob = await response.blob();
            const reader = new FileReader();

            return new Promise((resolve, reject) => {
              reader.onloadend = () =>
                resolve({ ...file, url: reader.result });
              reader.onerror = () => reject(new Error("Error reading file"));
              reader.readAsDataURL(blob);
            });
          } else {
            // console.warn(`Failed to fetch file: ${file.filename}`);
            return { ...file, url: null };
          }
        } catch (error) {
        //   console.error("Error processing file:", file.filename, error);
          return { ...file, url: null };
        }
      })
    );
  }



  const fetchFormData = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${getAuthToken('id_token')}`,
        },
      };
  
      const checkFemorBem = serviceType === "FEMS" ? "Fem" : "Bem";
      const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;
      const completionCategoryFieldName = workordercategory === "Scheduled" ? "Getscheduled" : "Getunscheduled";
        const id =rowData?.workorderId || "";
      const response = await axios.get(
        `${checkGraph}/api/${checkFemorBem}unscheduledworkorder/${completionCategoryFieldName}signatureList/${id},1,5000`,
        config
      );
  
      if (Array.isArray(response.data)) {
        const rowsData = response.data.map((item) => ({
          id: item?.id,
          name: item?.documenttitle || '',
          designation: item?.designation || '',
          fileType: item?.documenttype || '',
          size: item?.filesize || '',
          date: item?.signaturedate || '',
          filename: item?.filename || '',
        }));
  
  
        const getDeptuser = rowsData.filter(file => file.designation === "End-User");
        const getVendor = rowsData.filter(file => file.designation === "Vendor");
  
        const verifiedData = getDeptuser.length > 0 ? getDeptuser : getVendor;
        setVerifiedBy(rowsData);
  
    // if (verifiedData.length > 0) {
        //   console.log("Filename:", verifiedData[0]?.filename || 'No Filename Found');
        //   setFilename(verifiedData[0]?.filename || '');
        // } else {
        //   console.log("No verified data found.");
        // }
       
        try {
          const config = {
            headers: {
              Authorization: `Bearer ${getAuthToken('id_token')}`,
            },
          };
          if (Array.isArray(rowsData)) {
        
            const signatureArray = await processFilesWithUrls(rowsData, token);
            
  
            if (signatureArray && signatureArray.length > 0) {
          
              if (signatureArray[0]?.fileType === "txt" || signatureArray[0]?.fileType === "png") {
             
             
                const updatedSignatureArray = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${signatureArray[0]?.filename}`,config)
              setTxtFilenameUrl(updatedSignatureArray.data);
           
               const furtherProcessedArray = await processFilesWithUrls(signatureArray, token);
             
    
                  setFilenameUrl(furtherProcessedArray);
              } 
            // else if()
            //    {
         
            //     const furtherProcessedArray = await processFilesWithUrls(signatureArray, token);
            //  console.log(furtherProcessedArray ,"furtherProcessedArray ")
  
            //     setFilenameUrl(furtherProcessedArray);
            //   }
            } else {
            //   console.warn("Signature Array is empty or invalid.");
            }
          } else {
            // console.warn("Rows Data is not an array:", rowsData);
          }
        } catch (innerError) {
        //   console.error("Error processing files:", innerError);
        }
      } else {
        // console.warn("Unexpected response format:", response.data);
      }
    } catch (error) {
    //   console.error("Error fetching form data:", error);
    }
  };
  
  const decodeBase64 = (base64String) => {
    try {
      return atob(base64String);
    } catch (error) {
    //   console.error("Failed to decode base64 string:", error);
      return "";
    }
  };
//   console.log(reportData, "reportdata")


  useEffect(() => {
    const getData = async () => {
      await fetchData()
      await fetchFiles()
      await fetchFormData()
    }
    getData();
  }, [verifiedBy, reportData])

  useEffect(() => {

  }, [filenameUrl, txtFilenameUrl]);


  return (
    <>
      <div ref={ref}>
        <Paper className="record-paper" style={{ padding: '15px', maxWidth: '900px', margin: '0 auto', pageBreakAfter: 'always' }}>
          {/* Header */}
          <Grid container spacing={1} >
            <Grid item xs={12} sm={3}>
              <img src={reportslogo} alt="logo" style={{ maxWidth: '75px', height: '75px' }} />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} style={{ textAlign: 'center', marginTop: '10px' }}>
            <Typography style={{ fontWeight: 'bold', fontSize: '20px' }}>
              {data[0]?.workordercategory?.toUpperCase()} WORK ORDER
            </Typography>
          </Grid>
          <Grid item xs={6} sm={2} style={{ textAlign: 'center', marginTop: '10px', fontsize: '12px' }}>
            <Typography variant="subtitle2">{reportData?.workOrderNo}</Typography>
          </Grid>
          <Grid item xs={12}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontFamily: 'Arial, sans-serif',
              }}
            >
              {/* Section A: Work Order Details */}
              <thead>
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      backgroundColor: "#009999",
                      fontWeight: 'bold',
                      padding: '8px',
                      border: '1px solid #ddd',
                      width: '25%',
                      color: 'white',
                    }}
                  >
                    A. Work Order Details
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',

                    }}
                  >
                    Contract Number (if Any)
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Site
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >
                    {localStorage.getItem('FacilityName')}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Category
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >

                    {data[0]?.workordercategory}
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Type
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >
                    {reportData?.type?.label || ""}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Workgroup
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >
                    {data[0]?.workGroup}
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Week/Year
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >

                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Target Date
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >  {formatDates(reportData?.issueDateandTimeBasicDetails || "")}</td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Last PPM Date
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  ></td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Maintenance Source
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >
                    {reportData?.assessments?.repairType || ""}
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Reschedule Date
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  ></td>
                </tr>
              </tbody>
              <br></br>

              {/* Section B: Asset Details */}
              {/* <table> */}
              <thead>
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      backgroundColor: "#009999",
                      fontWeight: "bold",
                      padding: "8px",
                      border: "1px solid #ddd",
                      width: '25%',
                      color: 'white',
                    }}
                  >
                    B. Asset Details
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#f0f0f0",
                      width: '25%',
                    }}
                  >
                    Asset No
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                      width: '25%',
                    }}
                  >{data[0]?.assetNo}</td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#f0f0f0",
                      width: '25%',
                    }}
                  >
                    Old Asset No
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                      width: '25%',
                    }}
                  >{reportData?.oldAssetNo || ""}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#f0f0f0",
                      width: '25%',
                    }}
                  >
                    Asset Description
                  </td>
                  <td
                    colSpan="3"
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                      width: '25%',
                    }}
                  >{reportData?.description || ""}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#f0f0f0",
                      width: '25%',
                    }}
                  >
                    Serial Number
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                      width: '25%',
                    }}
                  >{reportData?.serialNo || ""}</td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#f0f0f0",
                      width: '25%',
                    }}
                  >
                    Model
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                      width: '25%',
                    }}
                  > {reportData?.modelNo || ""}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#f0f0f0",
                      width: '25%',
                    }}
                  >
                    Dept.Code
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                      width: '25%',
                    }}
                  >{data[0]?.department || ""}
                   </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#f0f0f0",
                      width: '25%',
                    }}
                  >
                    Loc. Code/Desc
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                      width: '25%',
                    }}
                  >{data?.[0]?.locationcode || ""}/{data?.[0]?.locationdesc || ""} </td>
                </tr>
              </tbody>
            </table>

          </Grid>
          <Grid item xs={12}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontFamily: 'Arial, sans-serif',
                textAlign: 'left',
              }}
            >
              {/* Section C: Vendor Details */}
              <thead>
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      backgroundColor: "#009999",
                      fontWeight: 'bold',
                      padding: '8px',
                      border: '1px solid #ddd',
                      width: '25%',
                      color: 'white'
                    }}
                  >
                    C. Vendor Details (if Outsource)
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#f0f0f0",
                      // width: '25%',
                    }}
                  >
                    Vendor Name
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                      // width: '25%',
                    }}
                  >{reportData?.assessments?.vendorName || ""}
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Vendor Code
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >{reportData?.assessments?.vendorCode || ""}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',


                    }}
                  >
                    Phone No.
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >{reportData?.assessments?.vendorPhoneNo || ""}
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Email
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >{reportData?.assessments?.vendorEmail || ""}
                  </td>
                </tr>
              </tbody>
              <br></br>
              {/* Section D: Employee Details */}
              <thead>
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      backgroundColor: "#009999",
                      fontWeight: 'bold',
                      padding: '8px',
                      border: '1px solid #ddd',
                      width: '25%',
                      color: 'white',
                    }}
                  >
                    D. Employee Details
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Employee ID
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >{reportData?.assessments?.employeeID || ""}</td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Employee Name
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >{reportData?.assessments?.employeeName || ""}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Start Date/Time
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >{formatDate(reportData?.assessments?.respondedStartDateandTime || "")}</td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    End Date/Time
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >{formatDate(reportData?.assessments?.respondedEndDateandTime || "")}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Response Hours (HH:MM)
                  </td>

                  <td
                    colSpan="4"
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >{reportData?.completionInfo?.duration || ""}</td>
                </tr>
              </tbody>
              <br></br>
              {/* Section E: Task Details */}
              <thead>
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      backgroundColor: "#009999",
                      fontWeight: 'bold',
                      padding: '8px',
                      border: '1px solid #ddd',
                      width: '25%',
                      color: 'white',
                    }}
                  >
                    E. Task Details
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Performance Test
                  </td>
                  <td
                    colSpan="3"
                    style={{
                      padding: '15px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                    
                    }}
                  >
                    <div style={{ display: 'flex', gap: '70px' }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input
                          type="checkbox"
                          checked={reportData?.performancetest?.startsWith('Done') || false}
                          disabled
                        />   Done
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input type="checkbox"
                          checked={reportData?.performancetest?.includes('Not Applicable') || false}
                          disabled />  Not Applicable
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input type="checkbox" checked={reportData?.performancetest?.startsWith('Not Done') || false} disabled /> Not Done
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input type="checkbox" checked={reportData?.performancetest?.includes('Fail') || false} disabled /> Fail
                      </label>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      padding: '15px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                     
                    }}
                  >
                    Electrical Safety Test
                  </td>
                  <td
                    colSpan="3"
                    style={{
                      padding: '15px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                    
                    }}
                  >
                     <div style={{ display: 'flex', gap: '50px' }}>
                     <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <input
                      type="checkbox"
                      checked={reportData?.electricalsafteytest?.startsWith('Done') || false}
                      disabled
                    /> Done
                    
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <input
                      type="checkbox"
                      checked={reportData?.electricalsafteytest?.includes('Not Applicable') || false}
                      style={{ marginLeft: '20px' }}
                      disabled
                    />   Not Applicable
                  
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <input
                      type="checkbox"
                      checked={reportData?.electricalsafteytest?.startsWith('Not Done') || false}
                      style={{ marginLeft: '20px' }}
                      disabled
                    />  Not Done
                   
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <input
                      type="checkbox"
                      checked={reportData?.electricalsafteytest?.includes('Fail') || false}
                      style={{ marginLeft: '20px' }}
                      disabled
                    />   Fail
                  
                    </label>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Date/Time Work Start
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >{formatDate(reportData?.completionInfo?.startDateandTime || "")}</td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#f0f0f0',
                      width: '25%',
                    }}
                  >
                    Date/Time Work Completed
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                      width: '25%',
                    }}
                  >{formatDate(reportData?.completionInfo?.endDateandTime || "")}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      backgroundColor: '#f0f0f0',
                      border: '1px solid #ddd',
                      width: '25%',
                    }}
                  >
                    Action Taken
                  </td>
                  <td
                    colSpan="3"
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                    }}
                  > {reportData?.completionInfo?.actionTaken || ""}</td>
                </tr>
                {/* </tbody>
            </table>
            <tbody> */}
                <tr>
                  <td colSpan="5" style={{ padding: '4px', border: '1px solid #ddd' }}>
                    <Typography
                      colSpan="4"
                      style={{
                        fontWeight: 'bold',
                        padding: '8px',
                        border: 'none',
                        textDecoration: 'underline', // Only underline the text
                      }}
                    >
                      Process Status
                    </Typography>




                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', alignItems: 'center' }}>
                      <div>
                      <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input type="checkbox"
                          checked={reportData?.
                            processstatus?.includes('Purpose For BER') || false}
                          style={{ marginLeft: '70px' }}
                          disabled /> Propose for BER
                             </label>
                      </div>
                      <div>
                      <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input type="checkbox"
                          checked={reportData?.processstatus?.includes('Required Parts') || false}
                          style={{ marginLeft: '70px' }}
                          disabled /> Require Parts
                             </label>
                      </div>
                      <div>
                      <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input type="checkbox"
                          checked={reportData?.processstatus?.includes('Equipment In Use') || false}
                          style={{ marginLeft: '30px' }}
                          disabled /> Equipment In Use
                             </label>
                      </div>
                      <div>
                      <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input type="checkbox"
                          checked={reportData?.
                            processstatus?.includes('Technical Advice') || false}
                          style={{ marginLeft: '70px' }}
                          disabled /> Technical Advice
                             </label>
                      </div>
                      <div>
                      <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input type="checkbox"
                          checked={reportData?.processstatus?.includes('Equipment not at Location') || false}
                          style={{ marginLeft: '70px' }}
                          disabled /> Equipment not at location
                             </label>
                      </div>
                      <div>
                      <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input type="checkbox"
                          checked={reportData?.
                            processstatus?.includes('Loaner Provision') || false}
                          style={{ marginLeft: '20px' }}
                          disabled /> Loaner Provision
                             </label>
                      </div>
                      <div>
                      <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <input type="checkbox"
                          checked={reportData?.
                            processstatus?.includes('Alternative Service') || false}
                          style={{ marginLeft: '15px' }}
                          disabled /> Alternative Service
                             </label>
                      </div>
                    </div>
                  </td>

                </tr>
              </tbody>
            </table>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
          </Grid>
          {/* Asset Details */}
          <Grid item xs={12}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontFamily: 'Arial, sans-serif',
                textAlign: 'left',
                border: '1px solid #ddd',
              }}
            >
              {/* F. Parts Details */}
              <thead>
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      backgroundColor: "#009999",
                      fontWeight: 'bold',
                      padding: '8px',
                      border: '1px solid #ddd',
                      color: 'white',
                    }}
                  >
                    F. Parts Details (if Required)
                  </td>
                </tr>
              </thead>
              {/* <tbody> */}
              <tr>
                <td
                  style={{
                    padding: '8px',
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #ddd',
                    width: '25%',
                  }}
                >
                  Part Code
                </td>
                <td
                  style={{
                    padding: '8px',
                    border: '1px solid #ddd',
                    backgroundColor: '#fff',
                    width: '25%',
                  }}
                >{reportData?.femunscheduledwopartsreplacedetails?.[0]?.itemPartCode?.label || ""}</td>
                <td
                  style={{
                    padding: '8px',
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #ddd',
                    width: '25%',
                  }}
                >
                  Part Description
                </td>
                <td
                  style={{
                    padding: '8px',
                    border: '1px solid #ddd',
                    backgroundColor: '#fff',
                    width: '25%',
                  }}
                >{reportData?.femunscheduledwopartsreplacedetails?.[0]?.itemDescription || ""}</td>
              </tr>
              <tr>
                <td
                  style={{
                    padding: '8px',
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #ddd',
                    width: '25%',
                  }}
                >
                  Quantity Used
                </td>
                <td
                  style={{
                    padding: '8px',
                    border: '1px solid #ddd',
                    backgroundColor: '#fff',
                    width: '25%',
                  }}
                >{reportData?.femunscheduledwopartsreplacedetails?.[0]?.quantity || ""}</td>
                <td
                  style={{
                    padding: '8px',
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #ddd',
                    width: '25%',
                  }}
                >
                  Part Cost
                </td>
                <td
                  style={{
                    padding: '8px',
                    border: '1px solid #ddd',
                    backgroundColor: '#fff',
                    width: '25%',
                  }}
                >{parseFloat(reportData?.femunscheduledwopartsreplacedetails?.[0]?.partCost || 0).toFixed(2)}</td>
              </tr>
              {/* </tbody> */}
            </table>
          </Grid>
          <br></br>

          {/* G. Verification Details */}
          <Grid>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <td
                    colSpan="6"
                    style={{
                      backgroundColor: "#009999",
                      fontWeight: "bold",
                      padding: "8px",
                      border: "1px solid #ddd",
                      color: "white",
                      textAlign: "center",
                    }}
                  >
                    G. Verification Details
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan="2"
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      padding: "8px",
                      border: "1px solid #ddd",
                    }}
                  >
                    (Engineering)
                  </td>
                  <td
                    colSpan="2"
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      padding: "8px",
                      border: "1px solid #ddd",
                    }}
                  >
                    (End User)
                  </td>
                  <td
                    colSpan="2"
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      padding: "8px",
                      border: "1px solid #ddd",
                    }}
                  >
                    (Outsource)
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #ddd",
                    }}
                  >
                    Completed By
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                    }}
                  >
                    {reportData?.completionInfo?.completionBy?.label || filenameUrl.find((file) => file.designation === "Technician")?.name
                      || ""}
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #ddd",
                    }}
                  >
                    Verified By
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                    }}
                  >
                    {filenameUrl.find((file) => file.designation === "End-User")?.name || ""}
                  </td>


                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #ddd",
                    }}
                  >
                    Completed By
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                    }}
                  >
                    {
                      reportData?.assessments?.vendorName
                      || filenameUrl.find((file) => file.designation === "Vendor")?.name
                      || ""
                    }
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #ddd",
                    }}
                  >
                    Designation
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                    }}
                  >
                    {filenameUrl.find((file) => file.designation === "Technician")?.designation || ""}
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #ddd",
                    }}
                  >
                    Designation
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                    }}
                  >
                    {filenameUrl.find((file) => file.designation === "End-User")?.designation || ""}
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #ddd",
                    }}
                  >
                    Designation
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                    }}
                  >
                    {filenameUrl.find((file) => file.designation === "Vendor")?.designation || ""}
                  </td>

                </tr>
                <tr>
                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #ddd",
                    }}
                  >
                    Signature Date
                  </td>


                  <td
          style={{
            padding: "8px",
            border: "1px solid #ddd",
            backgroundColor: "#fff",
          }}
        >
          {filenameUrl.some((file) => file.designation === "Technician") ? (
            filenameUrl
              .filter((file) => file.designation === "Technician")
              .map((file, index) => (
                <div key={file.id} style={{ marginBottom: "8px" }}>
                  {/\.(jpeg|jpg|png|gif|svg|bmp|webp)$/i.test(file.url) || file.url.startsWith("data:image") ? (
                    <img
                      src={file.url}
                      alt={`Technician Signature ${index + 1}`}
                      style={{
                        maxWidth: "100px",
                        maxHeight: "100px",
                        display: "block",
                        marginTop: "8px",
                      }}
                      onError={(e) => {
                        console.error("Failed to load image:", e.target.src);
                        e.target.src = ""; // Clear broken image
                      }}
                    />
                  ) : file.url.startsWith("data:text") ? (
                    <pre>{decodeBase64(file.url.split(",")[1])}</pre>
                  ) : (
                    <p>{file.url}</p>
                  )}
                  <p>{formatDates(file.date)}</p>
                </div>
              ))
          ) : (
            <p></p>
          )}
        </td>






                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #ddd",
                    }}
                  >
                    Signature Date
                  </td>

                  <td
          style={{
            padding: "8px",
            border: "1px solid #ddd",
            backgroundColor: "#fff",
          }}
        >
          {filenameUrl.some((file) => file.designation === "End-User") ? (
            filenameUrl
              .filter((file) => file.designation === "End-User")
              .map((file, index) => (
                <div key={file.id} style={{ marginBottom: "8px" }}>
                  {/\.(jpeg|jpg|png|gif|svg|bmp|webp)$/i.test(file.url) || file.url.startsWith("data:image") ? (
                    <img
                      src={file.url}
                      alt={`End-User Signature ${index + 1}`}
                      style={{
                        maxWidth: "100px",
                        maxHeight: "100px",
                        display: "block",
                        marginTop: "8px",
                      }}
                      onError={(e) => {
                        console.error("Failed to load image:", e.target.src);
                        e.target.src = ""; // Clear broken image
                      }}
                    />
                  ) : file.url.startsWith("data:text") ? (
                    <pre>{decodeBase64(file.url.split(",")[1])}</pre>
                  ) : (
                    <p>{file.url}</p>
                  )}
                  <p>{formatDates(file.date)}</p>
                </div>
              ))
          ) : (
            <p></p>
          )}
        </td>
                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #ddd",
                    }}
                  >
                    Signature Date
                  </td>
                  <td
          colSpan="3"
          style={{
            padding: "8px",
            border: "1px solid #ddd",
            backgroundColor: "#fff",
          }}
        >
          {filenameUrl.some((file) => file.designation === "Vendor") ? (
            filenameUrl
              .filter((file) => file.designation === "Vendor")
              .map((file, index) => (
                <div key={file.id} style={{ marginBottom: "8px" }}>
                  {/\.(jpeg|jpg|png|gif|svg|bmp|webp)$/i.test(file.url) || file.url.startsWith("data:image") ? (
                    <img
                      src={file.url}
                      alt={`Vendor Signature ${index + 1}`}
                      style={{
                        maxWidth: "100px",
                        maxHeight: "100px",
                        display: "block",
                        marginTop: "8px",
                      }}
                      onError={(e) => {
                        console.error("Failed to load image:", e.target.src);
                        e.target.src = ""; // Clear broken image
                      }}
                    />
                  ) : file.url.startsWith("data:text") ? (
                    <pre>{decodeBase64(file.url.split(",")[1])}</pre>
                  ) : (
                    <p>{file.url}</p>
                  )}
                  <p>{formatDates(file.date)}</p>
                </div>
              ))
          ) : (
            <p></p>
          )}
        </td>

                </tr>
              </tbody>
            </table>
          </Grid>

          <br></br>
          {/* H. Cost Details */}
          <Grid>
            <table>
              <thead>
                <tr>
                  <td colSpan="4"
                    style={{
                      backgroundColor: '#009999',
                      fontWeight: 'bold', padding: '8px',
                      border: '1px solid #ddd',
                      color: 'white',
                    }}>
                    H. Cost Details
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      backgroundColor: '#f0f0f0',
                      border: '1px solid #ddd',
                    }}
                  >
                    Breakdown Cost (RM)/PO Number
                  </td>
                  <td colSpan="3"
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                    }}
                  >{reportData?.completionInfo?.costInfo?.breakDownCost || 0}/{reportData?.completionInfo?.costInfo?.poNumber || 0}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      backgroundColor: '#f0f0f0',
                      border: '1px solid #ddd',
                    }}
                  >
                    PPM Cost (RM)/PO Number
                  </td>
                  <td colSpan="3"
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                    }}
                  >{reportData?.completionInfo?.costInfo?.ppmCostByContract || 0}/{reportData?.completionInfo?.costInfo?.ppmCostByPurchaseOrder || 0}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      backgroundColor: '#f0f0f0',
                      border: '1px solid #ddd',
                    }}
                  >
                    Spare Part Cost (RM)/Part Code
                  </td>
                  <td colSpan="3"
                    style={{
                      padding: '8px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff',
                    }}
                  >{parseFloat(reportData?.completionInfo?.costInfo?.totalSparePartCost || 0)?.toFixed(2)}</td>

                </tr>
                <td
                  style={{
                    padding: '8px',
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #ddd',
                  }}
                >
                  Total Work Order Cost (RM)
                </td>
                <td colSpan="3"
                  style={{
                    padding: '8px',
                    border: '1px solid #ddd',
                    backgroundColor: '#fff',
                  }}
                >{parseFloat(reportData?.completionInfo?.costInfo?.totalWorkorderCost || 0)?.toFixed(2)}</td>
              </tbody>
            </table>
          </Grid>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
            <thead>
              <tr>
                <td colSpan="7" style={{ backgroundColor: '#009999', color: 'white', fontWeight: 'bold', padding: '8px', border: '1px solid #ddd' }}>
                  I. Summary and Attachment
                </td>
              </tr>
              <tr>
                <td style={{ padding: '8px', backgroundColor: '#f0f0f0', border: '1px solid #ddd' }}>Task Description</td>
                <td style={{ padding: '8px', backgroundColor: '#f0f0f0', border: '1px solid #ddd' }}>Responded Employee</td>
                <td style={{ padding: '8px', backgroundColor: '#f0f0f0', border: '1px solid #ddd' }}>Completion Employee</td>
                <td style={{ padding: '8px', backgroundColor: '#f0f0f0', border: '1px solid #ddd' }}>Response Hours</td>
                <td style={{ padding: '8px', backgroundColor: '#f0f0f0', border: '1px solid #ddd' }}>Repair Hours</td>
                <td style={{ padding: '8px', backgroundColor: '#f0f0f0', border: '1px solid #ddd' }}>Total Work Cost (RM)</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{reportData?.assessments?.taskDescription || ""}</td>
                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{reportData?.assessments?.employeeName || ""}</td>
                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{reportData?.completionInfo?.completionBy?.label || reportData?.assessments?.vendorName || ""}</td>
                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{reportData?.completionInfo?.duration || ""}</td>
                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{reportData?.completionInfo?.downTimeHrs || ""}</td>
                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{parseFloat(reportData?.completionInfo?.costInfo?.totalWorkorderCost || 0)?.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
         
          <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
            <Grid container spacing={2}>
              {(beforeImageURL?.length > 0 || afterImageURL?.length > 0) && (
                <>
                  {/* Before Images */}
                  <Grid item xs={6}>
                    {beforeImageURL?.length > 0 ? (
                      <>
                        <h2>Before Work Image</h2>
                        <ImageList cols={1} gap={8} style={{ maxWidth: "100%" }}>
                          {beforeImageURL?.map((image, index) => (
                            <ImageListItem key={index} style={{ marginTop: "5px", position: "relative", overflowY: "hidden", }} >
                              <div
                                style={{
                                  width: "450px", // Increased fixed width for the box
                                  height: "350px", // Increased fixed height for the box
                                  borderRadius: "12px",
                                  border: "2px solid rgba(0, 0, 0, 0.1)",
                                  padding: "5px",
                                  boxShadow: "0 8px 15px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                  margin: "0 auto",
                                  transition: "transform 0.3s ease, box-shadow 0.10s ease",
                                  display: 'flex', // Use flexbox for centering the image
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  overflowY: "hidden",

                                }}
                              >
                                <img
                                  src={image?.url}
                                  alt={image?.documenttitle || "image"}
                                  style={{
                                    maxWidth: "100%", // Allow image to take up available width
                                    maxHeight: "100%", // Allow image to take up available height
                                    objectFit: "contain", // Maintain aspect ratio without cropping
                                    transition: "transform 0.3s ease, box-shadow 0.10s ease",
                                  }}
                                />
                              </div>
                              <ImageListItemBar title={image.documenttitle} style={{
                                width: "450px", // Increased fixed width for the box
                                height: "40px"
                              }} />
                              <br />
                            </ImageListItem>

                          ))}
                        </ImageList>
                      </>
                    ) : afterImageURL?.length > 0 ? (
                      <>
                        <h2>After Work Image</h2>
                        <ImageList cols={1} gap={8} style={{ maxWidth: "100%" }}>
                          {afterImageURL?.map((image, index) => (
                            <ImageListItem key={index} style={{ marginTop: "5px", position: "relative", overflowY: "hidden", }}>
                              <div
                                style={{
                                  width: "450px", // Increased fixed width for the box
                                  height: "350px", // Increased fixed height for the box
                                  borderRadius: "12px",
                                  border: "2px solid rgba(0, 0, 0, 0.1)",
                                  padding: "5px",
                                  boxShadow: "0 8px 15px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                  margin: "0 auto",
                                  transition: "transform 0.3s ease, box-shadow 0.10s ease",
                                  display: 'flex', // Use flexbox for centering the image
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  overflowY: "hidden",
                                }}
                              >
                                <img
                                  src={image?.url}
                                  alt={image?.documenttitle || "image"}
                                  style={{
                                    maxWidth: "50%", // Allow image to take up available width
                                    maxHeight: "50%", // Allow image to take up available height
                                    objectFit: "contain", // Maintain aspect ratio without cropping
                                    transition: "transform 0.3s ease, box-shadow 0.10s ease",
                                  }}
                                />
                              </div>
                              <ImageListItemBar title={image.documenttitle} style={{
                                width: "450px", // Increased fixed width for the box
                                height: "40px"
                              }} />
                              <br />
                            </ImageListItem>
                          ))}
                        </ImageList>
                      </>
                    ) : null}
                  </Grid>

                  {/* After Images */}
                  {beforeImageURL?.length > 0 && afterImageURL?.length > 0 && (
                    <Grid item xs={6}>
                      <h2>After Work Image</h2>
                      <ImageList cols={1} gap={8} style={{ maxWidth: "100%" }}>
                        {afterImageURL?.map((image, index) => (
                          <ImageListItem key={index} style={{ marginTop: "5px", position: "relative", overflowY: "hidden", }}>
                            {/* Fixed-size container for the image */}
                            <div
                              style={{
                                width: "450px", // Increased fixed width for the box
                                height: "350px", // Increased fixed height for the box

                                borderRadius: "12px",
                                border: "2px solid rgba(0, 0, 0, 0.1)",
                                padding: "5px",
                                boxShadow: "0 8px 15px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                margin: "0 auto",
                                transition: "transform 0.3s ease, box-shadow 0.10s ease",
                                display: 'flex', // Use flexbox for centering the image
                                alignItems: 'center',
                                justifyContent: 'center',

                              }}
                            >
                              <img
                                src={image?.url}
                                alt={image?.documenttitle || "image"}
                                style={{
                                  maxWidth: "100%", // Allow image to take up available width
                                  maxHeight: "100%", // Allow image to take up available height
                                  objectFit: "contain", // Maintain aspect ratio without cropping
                                  transition: "transform 0.3s ease, box-shadow 0.10s ease",

                                }}
                              />
                            </div>
                            <ImageListItemBar title={image.documenttitle} style={{
                              width: "450px", // Increased fixed width for the box
                              height: "40px"
                            }} />
                            <br />
                          </ImageListItem>
                        ))}
                      </ImageList>

                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </Box>
        </Paper>
      </div >
    </>


  );
});

export default VendorWorkorder